document.addEventListener('DOMContentLoaded', () => {

    const sections = document.querySelectorAll('.overlap-section');

    function updateParallax() {

        sections.forEach(section => {

            const leftImage =
                section.querySelector('.parallax-left');

            const rightImage =
                section.querySelector('.parallax-right');

            const singleImage =
                section.querySelector('.parallax-single');

            const rect = section.getBoundingClientRect();

            const move = rect.top * 0.08;

            if (leftImage) {

                leftImage.style.transform =
                    `translateX(${-move * 0.35}px)`;

            }

            if (rightImage) {

                rightImage.style.transform =
                    `translateX(${move * 0.7}px)`;

            }

            if (singleImage) {

                const horizontalMove = rect.top * -0.05;

                singleImage.style.transform =
                    `translateX(${horizontalMove}px)`;

            }

        });

    }

    window.addEventListener('scroll', updateParallax);

    updateParallax();





    const h1lm = document.querySelector('.h1lm');

h1lm.addEventListener('click', (e) => {

    const link = e.target.closest('a');

    if(!link) return;

    e.preventDefault();

   
    h1lm.querySelectorAll('a').forEach(a => {
        a.classList.remove('active');
    });

    
    link.classList.add('active');

    const id = link.getAttribute('data-id');

    const target = document.getElementById(id);

    if(target){

        const offset = 30;

        const top =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            offset;

        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });

    }

});



const topLink = document.getElementById('top_link');

topLink.addEventListener('click', (e) => {

    const link = e.target.closest('a');

    if (!link) return;

    e.preventDefault();

    topLink.querySelectorAll('a').forEach(a => {
        a.classList.remove('active');
    });

    link.classList.add('active');

    const id = link.getAttribute('data-id');
    const target = document.getElementById(id);

    if (target) {
        const offset = 30;

        const top =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            offset;

        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });
    }
});







new Splide( '.splide', {
  arrowPath: 'M17.5 3Q15.5 1 13.5 3L13.2 3.3Q11.2 5.3 13.2 7.3L23.8 18Q25.8 20 23.8 22L13.2 32.7Q11.2 34.7 13.2 36.7L13.5 37Q15.5 39 17.5 37L32.5 22Q34.5 20 32.5 18L17.5 3Z',
} ).mount();


});


